export default __webpack_public_path__ + "static/media/timericon.c4de342f.png";